import { useEffect, useMemo, useState, useRef } from "react";
import { debounce } from "lodash";
import { NewPasswordPopper } from "./NewPasswordPopper";
import IconButton from "../IconButton";

export const AuthInput = ({
    userName,
    onChange,
    readOnly,
    baseInputFieldType,
    required,
    icon,
    errors,
    helperText,
    label,
    isPasswordPopper = false,
    value,
}) => {
    const isPasswordField = baseInputFieldType === "password";
    const [showPassword, setShowPassword] = useState(false);
    const [textOfInput, setTextOfInput] = useState("");
    const [triggerd, setTriggerd] = useState(false);
    const [passError, setPassError] = useState(false);
    const [showPasswordPop, setShowPasswordPop] = useState(false);
    const [toPassCheck, setToPassCheck] = useState("");
    const inputRef = useRef(null);

    const debouncedChangeHandler = useMemo(
        () => debounce(setToPassCheck, 500)
        , []);

    useEffect(() => {
        debouncedChangeHandler(textOfInput);
    }, [debouncedChangeHandler, textOfInput]);

    return (
        <div className={"authInputContainer"}>
            <div className={"inputContainer"}>
                <label className={"inputLabel" + (readOnly ? " disabled" : "")} htmlFor="outlined-basic" id="outlined-basic-label" onClick={() => inputRef.current.focus()}>
                    <input
                        ref={inputRef}
                        autoComplete="off"
                        disabled={readOnly}
                        id="outlined-basic"
                        type={isPasswordField && !showPassword ? "password" : "text"}
                        onChange={(e) => {
                            setTextOfInput(e.target.value);
                            onChange?.(e.target.value);
                        }}
                        onFocus={() => {
                            isPasswordField && setShowPasswordPop(true);
                            setTriggerd(true);
                        }}
                        onBlur={() => {
                            if (value === null) {
                                onChange?.("");
                            }
                            setShowPasswordPop(false);
                        }}
                        placeholder={label}
                        value={value}
                    />
                    <span className={"title"}>
                        {label}
                        {required ? <span className='astrix'>*</span> : null}
                    </span>
                    <div className={"styledStartIcon"}>{icon}</div>
                </label>
                {errors && helperText ?
                    <div className={"helperText"}>{helperText.message}</div> : null
                }
                <div className={"styledStartIcon"}>{icon}</div>
                {isPasswordField && (
                    <IconButton
                        position="end"
                        onClick={() => setShowPassword(!showPassword)}>
                        {showPassword
                            ? svgObject.showPasswordNot
                            : svgObject.showPassword}
                    </IconButton>)}
                {isPasswordPopper && (
                    <NewPasswordPopper
                        triggerd={triggerd}
                        setPassError={setPassError}
                        password={toPassCheck}
                        isOpen={showPasswordPop} />
                )}
            </div>
        </div >
    );
};

const svgObject = {
    showPassword: <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M11.9104 5.59049C11.4274 4.54284 10.7198 3.61425 9.83793 2.87049L11.3539 1.35448L10.6464 0.646484L8.99993 2.29149C8.08861 1.76434 7.05269 1.49103 5.99993 1.49998C2.24993 1.49998 0.528435 4.63049 0.0894356 5.59049C0.0305047 5.71914 0 5.85898 0 6.00049C0 6.14199 0.0305047 6.28184 0.0894356 6.41049C0.572503 7.45813 1.28005 8.38673 2.16193 9.13049L0.646435 10.6465L1.35343 11.3535L2.99993 9.70849C3.91125 10.2356 4.94718 10.5089 5.99993 10.5C9.74993 10.5 11.4714 7.36949 11.9104 6.40949C11.9692 6.28098 11.9997 6.14131 11.9997 5.99999C11.9997 5.85866 11.9692 5.71899 11.9104 5.59049V5.59049ZM2.99993 5.99999C2.99899 5.44929 3.14989 4.90899 3.43606 4.43849C3.72223 3.96798 4.13259 3.58548 4.62202 3.33304C5.11145 3.0806 5.661 2.96799 6.21028 3.00759C6.75955 3.04718 7.28727 3.23745 7.73543 3.55749L7.00943 4.28349C6.70465 4.09969 6.35584 4.00173 5.99993 3.99999C5.4695 3.99999 4.96079 4.2107 4.58572 4.58577C4.21065 4.96085 3.99993 5.46955 3.99993 5.99999C4.00168 6.3559 4.09963 6.70471 4.28343 7.00949L3.55743 7.73549C3.19492 7.22941 2.99996 6.62251 2.99993 5.99999V5.99999ZM5.99993 8.99999C5.37741 8.99996 4.77052 8.80501 4.26443 8.44249L4.99043 7.71649C5.29521 7.90029 5.64402 7.99825 5.99993 7.99999C6.53037 7.99999 7.03907 7.78928 7.41415 7.4142C7.78922 7.03913 7.99993 6.53042 7.99993 5.99999C7.99819 5.64408 7.90023 5.29527 7.71643 4.99049L8.44243 4.26449C8.76246 4.71265 8.95273 5.24037 8.99233 5.78964C9.03193 6.33892 8.91931 6.88848 8.66687 7.37791C8.41443 7.86734 8.03194 8.27769 7.56143 8.56386C7.09093 8.85003 6.55063 9.00094 5.99993 8.99999V8.99999Z"
            fill="#C1C7CD"
        />
    </svg>,
    showPasswordNot: <svg
        width="12"
        height="10"
        viewBox="0 0 12 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M5.99925 6.9985C7.10341 6.9985 7.9985 6.10341 7.9985 4.99925C7.9985 3.8951 7.10341 3 5.99925 3C4.89509 3 4 3.8951 4 4.99925C4 6.10341 4.89509 6.9985 5.99925 6.9985Z"
            fill="#C1C7CD"
        />
        <path
            d="M11.6333 3.70888C10.8581 2.44635 9.09478 0.328125 5.99995 0.328125C2.90512 0.328125 1.14178 2.44635 0.366577 3.70888C-0.122192 4.49944 -0.122192 5.49835 0.366577 6.28893C1.14178 7.55146 2.90512 9.66968 5.99995 9.66968C9.09478 9.66968 10.8581 7.55146 11.6333 6.28893C12.1221 5.49835 12.1221 4.49944 11.6333 3.70888ZM5.99995 7.99778C4.34373 7.99778 3.00108 6.65512 3.00108 4.99889C3.00108 3.34266 4.34373 2 5.99995 2C7.65617 2 8.99882 3.34266 8.99882 4.99889C8.99716 6.65444 7.65549 7.99611 5.99995 7.99778Z"
            fill="#C1C7CD"
        />
    </svg>
};
